/**
 * True only in a `npm run build:staging` bundle (.env.staging sets
 * REACT_APP_ENV=staging; .env.production sets it to "production").
 *
 * CRA inlines the value at build time, so in a production bundle every
 * `IS_STAGING_BUILD && ...` below is a constant false. Staging-only admin tools
 * (the email outbox, "Send recommendations now") key on this, and their server
 * routes answer 404 anywhere but staging as well.
 */
export const IS_STAGING_BUILD = process.env.REACT_APP_ENV === 'staging';
